"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skill = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const renderer_1 = require("@react-pdf/renderer");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const ApplicantProfilePDF_styles_1 = require("../ApplicantProfilePDF.styles");
const skillLevelMap = {
    5: 'profile.resume.skills.level.expert',
    4: 'profile.resume.skills.level.advanced',
    3: 'profile.resume.skills.level.intermediate',
    2: 'profile.resume.skills.level.elementary',
    1: 'profile.resume.skills.level.beginner',
};
const Skill = ({ skills, areSkillsRated }) => {
    const skillTagRatingWidthMultiplier = 35;
    const maxPossibleSkillRating = 5;
    if (!skills) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: skills === null || skills === void 0 ? void 0 : skills.map(skill => ((0, jsx_runtime_1.jsxs)(renderer_1.View, { style: ApplicantProfilePDF_styles_1.styles.skillItem, children: [areSkillsRated && ((0, jsx_runtime_1.jsx)(renderer_1.View, { style: ApplicantProfilePDF_styles_1.styles.skillTagTextWrapper, children: (0, jsx_runtime_1.jsxs)(renderer_1.Text, { style: ApplicantProfilePDF_styles_1.styles.tagText, children: [skill.value, ' ', (0, jsx_runtime_1.jsxs)(renderer_1.Text, { style: ApplicantProfilePDF_styles_1.styles.skillTagShadowText, children: ["(", (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `${skillLevelMap[skill.rating]}` }), ")"] })] }) })), !areSkillsRated && ((0, jsx_runtime_1.jsx)(renderer_1.View, { style: ApplicantProfilePDF_styles_1.styles.tag, children: (0, jsx_runtime_1.jsx)(renderer_1.Text, { style: ApplicantProfilePDF_styles_1.styles.tagText, children: skill.value }) }, skill.value)), skill.rating && ((0, jsx_runtime_1.jsx)(renderer_1.View, { style: [
                        ApplicantProfilePDF_styles_1.styles.skillLineRange,
                        { width: maxPossibleSkillRating * skillTagRatingWidthMultiplier },
                    ], children: (0, jsx_runtime_1.jsx)(renderer_1.View, { style: [ApplicantProfilePDF_styles_1.styles.skillLine, { width: skill.rating * skillTagRatingWidthMultiplier }] }) }))] }, skill.id))) }));
};
exports.Skill = Skill;
